import { render, staticRenderFns } from "./IntegralMonitor.vue?vue&type=template&id=37fb12e8"
import script from "./IntegralMonitor.vue?vue&type=script&lang=js"
export * from "./IntegralMonitor.vue?vue&type=script&lang=js"
import style0 from "./IntegralMonitor.vue?vue&type=style&index=0&id=37fb12e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports